import { render, staticRenderFns } from "./uvc.vue?vue&type=template&id=4be086f9&scoped=true&"
import script from "./uvc.vue?vue&type=script&lang=js&"
export * from "./uvc.vue?vue&type=script&lang=js&"
import style0 from "./uvc.vue?vue&type=style&index=0&id=4be086f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be086f9",
  null
  
)

export default component.exports